/* NUTSH LAB - text del formulari de Shopify Forms (HOME i MISIO).
   El text viu dins de l'app de formularis, no al tema, i no es pot
   editar per API. Mentre no s'editi alla, aqui es corregeix al navegador:
     - treu "September 2026": la data de llancament encara no esta fixada
     - posa el camp de correu en angles, com la resta de la pagina
   Quan David editi el text a l'app, aquest fitxer es pot treure.
   Rev. 17 Sep 2026 (a) */
(function () {
  var PAIRS = [['Launching September 2026.', 'Launching soon.']];

  function fix(t) {
    if (t.indexOf('Correo') === 0) return 'Email';
    var out = t;
    for (var i = 0; i < PAIRS.length; i++) {
      out = out.split(PAIRS[i][0]).join(PAIRS[i][1]);
    }
    return out;
  }

  function scan(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v) continue;
      var t = v.trim();
      if (!t) continue;
      var out = fix(t);
      if (out !== t) n.nodeValue = out;
    }
    var els = root.querySelectorAll('[placeholder],[aria-label]');
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      var attrs = ['placeholder', 'aria-label'];
      for (var k = 0; k < attrs.length; k++) {
        var av = el.getAttribute(attrs[k]);
        if (!av || !av.trim()) continue;
        var ao = fix(av.trim());
        if (ao !== av.trim()) el.setAttribute(attrs[k], ao);
      }
    }
  }

  function run() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) scan(hosts[i].shadowRoot);
    }
  }

  var tries = 0;
  var t = setInterval(function () {
    tries++;
    run();
    if (tries > 160) clearInterval(t);
  }, 250);
  run();
})();
